import { AccuracyInspectionSupplement } from "@app/projects/results/accuracy";
import { formatUnconvertedDateCustom } from "@app/shared";
import { wafflesKeyColumnName } from "@app/shared/waffles";
import InspectionProfileTableData from "./inspectionProfileTableData";
import { getSupplementalDataDecoration, valueOrDashes } from "./utils";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

const unknownSourceName = "UNKNOWN";

/* eslint-disable sort-keys */
const generateDefaultProviderPanelRow = (rowKey: string, title: string, sourceValue: string, supplement: AccuracyInspectionSupplement<string>, supplementValueOveride: string = null): InspectionProfileTableData => {
  return {
    [wafflesKeyColumnName]: rowKey,
    title: title,
    source: valueOrDashes(sourceValue),
    result: (
      supplement ?
        getSupplementalDataDecoration((supplementValueOveride) ? supplementValueOveride : supplement.value, supplement.supplementalType, sourceValue)
        :
        <span className="text-muted">
          <QesIcon iconName={QesIcons.FontAwesome.Question} width="8" description="the accuracy of this information is unknown" classNames="mx-2" />
        </span>
    ),
    reference: (
      (supplement && supplement.sourceName.toUpperCase() !== unknownSourceName) ?
        <span>
          {valueOrDashes(supplement.sourceName)}
          &nbsp;
          {(supplement.sourceName) ?
            valueOrDashes(supplement.sourceDate ? `(${formatUnconvertedDateCustom(supplement.sourceDate, "L")})` : "") :
            null
          }
        </span> :
        <span>{"---"}</span>)
  }
}

export default generateDefaultProviderPanelRow;